import { render, staticRenderFns } from "./page-loader.html?vue&type=template&id=13021e86&scoped=true&"
import script from "./page-loader.ts?vue&type=script&lang=ts&"
export * from "./page-loader.ts?vue&type=script&lang=ts&"
import style0 from "./page-loader.scss?vue&type=style&index=0&id=13021e86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13021e86",
  null
  
)

export default component.exports